<template>
	<td style="text-align:center"><icon-button name="menu-18" class="fd-array-handle" @pointerdown="prepareForDragging" @pointerup="noDragging"></icon-button></td>
</template>

<script setup lang="ts">
import {injectCellAPI, rowContextKey} from "./AgendaUtils";
import {inject} from "vue";
import IconButton from "@fd/helpers/IconButton.vue";
import {Column} from "@t/agenda/Columns.ts";

const props = defineProps<{
	object: object,
	col: Column,
}>();

const api = injectCellAPI();
const rowContext = inject(rowContextKey);

function prepareForDragging(e:PointerEvent) {
	api.action("sort-start", 0, {}, rowContext.value, e);
}

function noDragging(e:PointerEvent) {
	api.action("sort-stop", 0, {}, rowContext.value, e);
}
</script>

<style>

</style>